var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowAqe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 8,
    fill: "none",
    viewBox: "0 0 10 8"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "arrow-aqe-path",
    fill: "#004C6A",
    fillRule: "evenodd",
    d: "M5 8L.155 1.41C-.026 1.136-.05.78.093.483.235.186.52 0 .833 0h8.333c.313 0 .599.186.741.484.143.296.12.653-.062.925L5 8z",
    clipRule: "evenodd"
  })));
}
export default SvgArrowAqe;